import React from 'react';
import Button from "../../form/Button"

const TheTrihurstContent = ({data}) => {
  return (
    <>
      <div className="relative w-3/5 z-10">
        <h4 className="text-xl font-semibold mb-2 text-primary uppercase">{data.SubTitle}</h4>
        <h2 className="text-5xl text-white font-semibold mb-3 max-w-[682]">{data.title}</h2>
        <div className="text-xl leading-relaxed text-secondary mt-5">
          <p>
           {data.description}
          </p>
        </div>
        <div className="relative flex items-center space-x-4 mt-10">
          <Button
            buttonClasses={"!h-12 xls:!h-14 !rounded-4 !px-4 md:!px-6 !border !border-primaryBorder md:!min-w-[180px] uppercase"}
            buttonHasLink={false}
            buttonType={'button'}
            buttonLabel={"Buy Crypto"}
            buttonLabelClasses={"text-base xls:!text-lg"}
          />
          <Button
            buttonClasses={"!h-12 xls:!h-14 !rounded-4 !px-4 md:!px-6 !border !bg-buttonRed !border-borderButtonRed md:!min-w-[180px] uppercase"}
            buttonHasLink={true}
            buttonLink={"/"}
            buttonLabel={"Sell Crypto"}
            buttonLabelClasses={"text-base xls:!text-lg"}
          />
        </div>
      </div>
    </>
  )
}

export default TheTrihurstContent;